import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Dropdown from './dropdown';

export default class DropdownElement extends PureComponent {
    static propTypes = {
        items: PropTypes.array,
        xAlign: PropTypes.string,
        defaultXPosition: PropTypes.string,
        itemComponent: PropTypes.any,
        onDropdownShow: PropTypes.func,
        onDropdownHide: PropTypes.func,
        onItemClick: PropTypes.func,
        children: PropTypes.any
    };

    static defaultProps = {
        items: [],
        closeOnEveryClick: true
    };

    state = {
        dropdownVisible: this.props.dropdownVisible
    };

    handleClick = () => {
        this.showDropdown();
    }

    handleDropdownShow = () => {
        this.setState({
            dropdownVisible: true
        });

        this.props.onDropdownShow && this.props.onDropdownShow();
    }

    handleDropdownHide = () => {
        this.setState({
            dropdownVisible: false
        });

        this.props.onDropdownHide && this.props.onDropdownHide();
    }

    showDropdown() {
        if (this.state.dropdownVisible || !this.dropdownCtrl) {
            return;
        }

        this.dropdownCtrl.show();

        const documentClickHandler = event => {
            if (!this.props.closeOnEveryClick && !(event.target.closest && event.target.closest('.app'))) {
                return;
            }

            this.hideDropdown();

            document.removeEventListener('click', documentClickHandler);
        };

        setTimeout(() => {
            document.addEventListener('click', documentClickHandler);
        }, 0);
    }

    hideDropdown() {
        if (!this.state.dropdownVisible || !this.dropdownCtrl) {
            return;
        }

        this.dropdownCtrl.hide();   
    }

    setDropdownCtrl = ctrl => this.dropdownCtrl = ctrl;

    componentDidMount() {
        if (this.props.autoShow) {
            this.showDropdown();
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.autoShow && this.props.autoShow) {
            this.showDropdown();
        }
    }

    render() {
        if (this.props.readonly) {
            return this.props.children;
        }

        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleClick,
                className: (child.props.className || '') + (this.state.dropdownVisible ? ' selected' : '')
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Dropdown
                    className={this.props.dropdownClassName}
                    withSearch={this.props.withSearch}
                    title={this.props.title}
                    items={this.props.items}
                    xAlign={this.props.xAlign}
                    defaultYPosition={this.props.defaultYPosition}
                    defaultXPosition={this.props.defaultXPosition}
                    itemComponent={this.props.itemComponent}
                    provideController={this.setDropdownCtrl}
                    onShow={this.handleDropdownShow}
                    onHide={this.handleDropdownHide}
                    onItemClick={this.props.onItemClick}
                />
            </React.Fragment>
        );
    }
}
